import axios from "axios";
// List products with Api
export const PositionInsert = async (jwt,user_id,course_id,urlc) => {

  let url = process.env.REACT_APP_ADMIN_API_URL + `/position`
  let data = "";
  let qs = require('qs');
  data = qs.stringify({
    'user_id': user_id,
    'course_id': course_id,
    "url": urlc
  });
  try {
    const response = await axios.post(
        url,
        data,
      {
        headers: {
            'Authorization': 'Bearer '+jwt, 
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
    return response.data

  } catch (error) {
      console.log(error)
      sessionStorage.removeItem('userSelect');
    throw error;
  }
};